import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { BrowserModule } from '@angular/platform-browser';

@Component({
  selector: 'emi-pagination',
  standalone: true,
  imports: [BrowserModule, MatIconModule],
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.css']
})
export class PaginationComponent implements OnInit, OnChanges {
  @Input() totalPages: number = 0;
  @Input() actuallyPage: number = 1;
  @Output() changePage = new EventEmitter<number>();

  pages: Array<any> = [];
  actualPage: number = 1;
  totalPage: number = 1;
  maxPages: number = 5;
  ngOnInit() {

  }

  ngOnChanges() {
    this.totalPage = this.totalPages;
    this.actualPage = this.actuallyPage;
    //Si en la vista no exitsen las páginas necesarias, las generamos
    if (this.requiredReload() || this.actualPage === 1) {
      //Buscamos el primer y último elemento
      const firstElemet = this.getFisrtElement();
      const lastElement = firstElemet <= 1 ? this.maxPages : firstElemet + this.maxPages;
      this.generatePages(firstElemet, lastElement);
    }


  }

  private requiredReload(): boolean {
    if (this.pages.length <= 1) {
      return true;
    }
    return !this.pages.some(page => page.label === this.actualPage);
  }

  private getFisrtElement(): number {
    if (this.actualPage <= this.maxPages) {
      return 1;
    }
    return (this.actualPage - this.maxPages) + 1;
  }



  private generatePages(firstElemet: number, lastElement: number) {
    this.pages = [];
    //Creamos el arreglo de páginas
    for (let i = firstElemet; i <= lastElement; i++) {
      if (i > this.totalPage) {
        break;
      }
      this.pages.push({
        value: i - 1,
        label: i,
        active: i === this.actuallyPage
      });
    }
    console.log(this.pages);
  }

  public selectPage(page: number) {
    this.changePage.emit(page);
  }


  public nextPage() {
    const page = this.actualPage + 1;
    if (page > this.totalPage) {
      return;
    }
    this.changePage.emit(page);
  }
  public previousPage() {
    const page = this.actualPage - 1;
    if (page < 1) {
      return;
    }
    this.changePage.emit(page);
  }
}
